export enum StringBoolean {
  TRUE = 'true',
  FALSE = 'false',
}
